import api from "@/api";

/**
 * Serialize params theo chuẩn Spring:
 * userIds=1&userIds=5&userIds=6
 * (KHÔNG có userIds[])
 */
function serializeParams(params) {
  const usp = new URLSearchParams();

  Object.keys(params || {}).forEach((key) => {
    const val = params[key];
    if (val === null || val === undefined) return;

    if (Array.isArray(val)) {
      val.forEach((v) => usp.append(key, v));
    } else {
      usp.append(key, val);
    }
  });

  return usp.toString();
}

export default {
  // ===== USER =====
  my(month) {
    return api.get("/api/phieu-cong-luong/my", {
      params: { month },
    });
  },

  confirmCong(month) {
    return api.post("/api/phieu-cong-luong/my/confirm-cong", null, {
      params: { month },
    });
  },

  // ===== ADMIN =====

  adminList(month, userIds = []) {
    return api.get("/api/phieu-cong-luong/admin/list", {
      params: { month, userIds },
      paramsSerializer: serializeParams,
    });
  },

  publishCongAll(month, userIds = []) {
    return api.post("/api/phieu-cong-luong/admin/publish-cong-all", null, {
      params: { month, userIds },
      paramsSerializer: serializeParams,
    });
  },

  sendLuongAll(month, userIds = []) {
    return api.post("/api/phieu-cong-luong/admin/send-luong-all", null, {
      params: { month, userIds },
      paramsSerializer: serializeParams,
    });
  },

  sendLuongOne(userId, month) {
    return api.post("/api/phieu-cong-luong/admin/send-luong-one", null, {
      params: { userId, month },
    });
  },
};
